import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { wowImageDriverFactory } from '../WowImage/WowImage.driver';

export interface ImageDriver extends BaseUniDriver {
  getSrc(): Promise<string>;
  getAlt(): Promise<string>;
  isLoaded(): Promise<boolean>;
  isError(): Promise<boolean>;
}

export const imageDriverFactory = (base: UniDriver): ImageDriver => {
  return {
    ...wowImageDriverFactory(base),
  };
};
